<template>
  <div class="srv-categories-container">
    <div class="l-box l-box--wide srv-categories">
      <button
        v-for="category in categories"
        @click="handleUpdate(category.value)"
        :class="{ 'is-active': activeCategory === category.value }"
      >
        {{ category.label }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Categories',
  props: ['updateFilter', 'categories', 'activeCategory'],
  methods: {
    handleUpdate(value) {
      this.updateFilter({ category: value, tag: '' });
    }
  }
};
</script>

<style scoped>
.srv-categories-container {
  height: 50px;
  border-bottom: 1px solid #d6cecc;
  overflow: hidden;
}

.srv-categories {
  height: 150%;
  white-space: nowrap;
  overflow-x: auto;
}

.srv-categories button {
  padding: 0.5em 0.5em 1em;
  border-radius: 0;
  color: #bbb;
  font-weight: bold;
  line-height: 1.6;
  cursor: pointer;
  transition: color 0.25s, box-shadow 0.25s;
}

.srv-categories button:focus,
.srv-categories button:active {
  outline: none;
}

.srv-categories button.is-active {
  color: inherit;
  box-shadow: 0 -4px 0 -2px #ea5c6f inset;
}
</style>



// WEBPACK FOOTER //
// src/components/categories.vue